import { useEffect, useState } from 'react';
import Button from 'components/ui-components/Button';
import TextInput from 'components/ui-components/TextInput';
import styled from 'styled-components';
import { useHTTP } from 'hooks/useRequest';
import { gaMFAError } from '../../../../data_layer/ga_authentication_events';

const ResendCodeForm = ({ resetCountdown, username }) => {
  const [clicked, setClicked] = useState(false);
  const [password, setPassword] = useState('');
  const [validateErrors, setValidateErrors] = useState(false);
  const [error, setError] = useState({});

  const resendCodeRequestConfig = {
    method: 'POST',
    url: clicked ? '/session' : null,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: JSON.stringify({ session: { username, password } }),
  };

  const {
    data: resendCodeResponse,
    error: resendCodeError,
    loading,
  } = useHTTP(resendCodeRequestConfig || null);

  const validatePassword = string => {
    const hasPassword = string !== '';

    setError(
      !hasPassword
        ? { password: { message: 'Please enter your password' } }
        : {},
    );

    return hasPassword;
  };

  const handleClick = () => {
    setValidateErrors(true);

    const success = validatePassword(password);

    if (success) setClicked(true);
  };

  useEffect(() => {
    if (validateErrors) validatePassword(password);
  }, [password, validateErrors]);

  useEffect(() => {
    setClicked(false);

    const errors = resendCodeError?.error?.data?.errors;
    const errorRedirect = resendCodeError?.error?.data?.url;

    if (resendCodeResponse?.success) {
      resetCountdown(
        resendCodeResponse?.secondsUntilNextRequest,
        resendCodeResponse?.requestLimitReached,
      );
    } else if (errorRedirect !== undefined) {
      window.location.href = errorRedirect;
    } else if (errors !== undefined) {
      gaMFAError(errors);
      setError({ password: { message: Object.values(errors)[0] } });
    }
  }, [resendCodeResponse, resendCodeError]);

  const handleChange = e => setPassword(e.target.value);

  return (
    <div className="bg-grey-3 ptb-25 plr-16">
      <TextInput
        label="Password"
        description="Please enter your password to resend a code"
        variant="feature"
        type="password"
        id="password"
        value={password}
        onChange={handleChange}
        errors={error}
      />
      <ContinueButton
        handleClick={handleClick}
        className="cef-btn cef-btn--small-feature cef-btn--grey mt-24 width-100">
        {loading ? <span className="cef-btn__loader bs-bb" /> : 'Continue'}
      </ContinueButton>
    </div>
  );
};

const ContinueButton = styled(Button)`
  max-width: 180px;
`;

export default ResendCodeForm;
